var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.currentPath !== '/' && _vm.currentPath !== '/home' ? 'footer' : 'footer-home'},[_c('div',{staticClass:"footer-text inter"},[_vm._v(" Copyright © 2024 宇宙商旅（深圳）有限公司 All rights reserved ")]),_c('div',{staticClass:"footer-text inter",staticStyle:{"margin-top":"10px"},on:{"click":_vm.toBeiAn}},[_vm._v(" 粤ICP备2025370032号 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }